module.exports = __webpack_public_path__ + "449d681cd6006390e1bee3c3a660430b.woff";